export default {
	sentryDsn: '',
	applicationPublicPath: '/',
	sentryTracingDomains: ['localhost'],
	openReplayProject: 'jIMYCRNbnVAN2bQFQ3Y1',
	pensionInfoWindowUrl: 'https://pensionsinfo-v3-test.dk',
}
